import { globalVariables } from "helper/globalVariables";
import { Phone, Mail, Location, StarBlack, Distance } from "helper/images";
import { globalClasses } from "helper/globalClasses";
import { ROLE } from "helper/utility";

const { iconCls } = globalClasses;

export function ContactDetails({ userDetail }) {
  const isJudge = userDetail?.role === ROLE.Judge;
  return (
    <div className="flex flex-col p-4 gap-4 rounded-xl bg-white">
      <div className="flex flex-col gap-4 pb-4">
        <div className="flex flex-row gap-2 text-base">
          <Mail className={iconCls} />
          <span className="text-base">{userDetail.email}</span>
        </div>
        <div className="flex flex-row gap-2 text-base">
          <Phone className={iconCls} />
          <span className="text-base">{userDetail.phoneNumber}</span>
        </div>
        <div className="flex items-start space-x-2">
          <span className="w-5"><Location /></span>
          <div className="flex flex-col">
            <span className="text-base">{userDetail.address}</span>
            <span className="text-base">{userDetail.city}, {userDetail.state?.replace(/.*-\s*/, "")} {userDetail.zipCode}</span>
          </div>
        </div>
        {isJudge && (
          <>
            <div className="flex flex-row gap-2 text-base">
              <Distance className={iconCls} />
              <span className="text-base">
                {globalVariables.distanceReadyToTravel}:{" "}
                {userDetail.distanceTravel}km
              </span>
            </div>
            <div className="flex flex-row gap-2 text-base">
              <StarBlack className={iconCls} />
              <span className="text-base">{userDetail?.level}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
